module.exports = __webpack_public_path__ + "static/media/image-card-4.5f40a7d5.png";